import styled from "styled-components";

export const StyledNotification = styled.div`
 
`;
